import { createRepositoriesModalOptions } from 'modals/modal-options-factory';
import { getSessionModifyFF } from 'common/services/init.service';
import { useEffect } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import {
  TRACKING,
  PROVIDERS_FETCH_LARGE_REPOS_FF,
  LOCAL_STORAGE_KEYS,
  IDENTITY_PROVIDERS
} from 'common/constants/constants';
import _ from 'lodash';
import { JOB_NAMES } from 'common/services/jobs-suites.service';
import moment from 'moment';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const AddRepositories = ({
  account,
  getOrganization,
  gitSensorAuthorizations,
  repositories = [],
  toggleModal,
  createRepositories,
  deleteSensorAuthorization,
  toggleSnackBar,
  getJobDetails
}) => {
  const {
    is_pat: isPat,
    id: sensorAuthId,
    sensor_name: sensorName
  } = gitSensorAuthorizations?.[0] || {};
  const localStorageAccessor = BrowserStorageAccessor().local;

  useEffect(() => {
    const shouldLogConnectGitSuccess =
      repositories &&
      !repositories.length &&
      localStorageAccessor.get(
        LOCAL_STORAGE_KEYS.SHOULD_LOG_GIT_CONNECT_SUCCESS
      );
    if (shouldLogConnectGitSuccess) {
      TrackingService.logEvent(TRACKING.EVENTS.SETUP_WIZARD_CONNECT_GIT_OK, {
        identity_email: account?.email,
        git_provider: sensorName,
        auth: isPat ? 'pat' : 'oauth'
      });
      localStorageAccessor.set(
        LOCAL_STORAGE_KEYS.SHOULD_LOG_GIT_CONNECT_SUCCESS,
        false
      );
    }
  }, []);
  const isFetchLargeRepos = JSON.parse(
    _.get(
      getSessionModifyFF(),
      _.get(PROVIDERS_FETCH_LARGE_REPOS_FF, [sensorName], '').toLowerCase(),
      sensorName !== IDENTITY_PROVIDERS.BITBUCKET_SERVER
    )
  );
  const isGithubFetchAllRepoTypesFF = JSON.parse(
    _.get(
      getSessionModifyFF(),
      FEATURE_FLAGS_NAMES.githubFetchAllRepoTypes.toLowerCase(),
      true
    )
  );

  const openRepositoriesModal = () => {
    toggleModal(
      createRepositoriesModalOptions({
        repositories,
        createRepositories,
        account,
        toggleModal,
        gitSensorAuthorizations,
        sensor_authorization_id: sensorAuthId,
        deleteSensorAuthorization,
        backfillType: 'Onboarding',
        validateRepos: true,
        toggleSnackBar,
        onSubmitCb: async ({
          repositories,
          available_repositories,
          isV2 = false
        }) => {
          if (isV2) {
            await getJobDetails(JOB_NAMES.REPOSITORIES_COLLECTOR);
            // key that says user clicked save
            BrowserStorageAccessor().local.set(
              LOCAL_STORAGE_KEYS.USER_SAVED_REPOS_TS,
              moment().format()
            );
          } else {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.ONBOARDING,
              page_tab: TRACKING.PAGE_TABS.SELECT_REPOS,
              click_type: TRACKING.CLICK.CONTINUE,
              num_avail_repos: available_repositories.length,
              num_of_repos: repositories.length
            });
          }
          await getOrganization(); // make sure to update the org info which may have changed after we submitted repos
          toggleModal();
        },
        isFetchLargeRepos,
        isGithubFetchAllRepoTypesFF
      })
    );
  };

  useEffect(() => {
    if (!repositories.length) {
      openRepositoriesModal();
    }
  }, [repositories]);

  return null;
};

export default AddRepositories;
